module.exports = __webpack_public_path__ + "static/media/nav-icon--loop.f0cd8ad4.svg";